__turbopack_context__.v({
  "box": "SummaryBox-module-scss-module__WDDxxW__box",
  "fade-in": "SummaryBox-module-scss-module__WDDxxW__fade-in",
  "label": "SummaryBox-module-scss-module__WDDxxW__label",
  "no-transform": "SummaryBox-module-scss-module__WDDxxW__no-transform",
  "rotate": "SummaryBox-module-scss-module__WDDxxW__rotate",
  "value": "SummaryBox-module-scss-module__WDDxxW__value",
});
